"use client";

import { useRevealOnScroll } from "@/hooks/useRevealOnScroll";
export default function ResidentialRenovations() {
  const {
    ref: headerRef,
    isVisible: headerVisible
  } = useRevealOnScroll({
    threshold: 0.2
  });
  const {
    ref: service1Ref,
    isVisible: service1Visible
  } = useRevealOnScroll({
    threshold: 0.2
  });
  const {
    ref: service2Ref,
    isVisible: service2Visible
  } = useRevealOnScroll({
    threshold: 0.2
  });
  const {
    ref: service3Ref,
    isVisible: service3Visible
  } = useRevealOnScroll({
    threshold: 0.2
  });
  const {
    ref: service4Ref,
    isVisible: service4Visible
  } = useRevealOnScroll({
    threshold: 0.2
  });
  return <section id="residentialrenovations" className="py-16 px-6 md:py-24 bg-background">
      <div className="max-w-4xl mx-auto">
        <div ref={headerRef} className={`text-center mb-12 transition-all duration-700 ${headerVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-8"}`}>
          <span className="!text-[hsl(32,29%,42%)] !text-xs !font-medium tracking-widest">RESIDENTIAL RENOVATIONS</span>
          <h2 className="text-4xl font-display font-bold text-foreground tracking-wide ![margin:24px_0px_24px_0px] md:text-5xl">Luxury Residential Renovations</h2>
          <p className="text-muted-foreground font-sans leading-relaxed max-w-2xl mx-auto !text-lg">We specialise in bespoke home renovations that enhance both lifestyle and architectural identity. Our approach balances functionality, refined design, and premium craftsmanship. Our residential services include:</p>
        </div>

        <div className="space-y-8">
          <div ref={service1Ref} className={`border-l-4 border-[#a03223] pl-6 py-4 transition-all duration-700 delay-100 ${service1Visible ? "opacity-100 translate-x-0" : "opacity-0 -translate-x-8"}`}>
            <h3 className="text-2xl font-display font-semibold mb-3 text-foreground">
              Whole Home Transformations
            </h3>
            <p className="text-muted-foreground font-sans leading-relaxed !text-base">Complete interior reconfigurations that modernise your home while respecting its architectural character.</p>
          </div>

          <div ref={service2Ref} className={`border-l-4 border-accent pl-6 py-4 transition-all duration-700 delay-200 ${service2Visible ? "opacity-100 translate-x-0" : "opacity-0 -translate-x-8"}`}>
            <h3 className="text-2xl font-display font-semibold mb-3 text-foreground">
              Full Interior Reimagining
            </h3>
            <p className="text-muted-foreground font-sans leading-relaxed !text-[17px]">From layout optimisation to material selection, we redefine interiors with elegance and purpose.</p>
          </div>

          <div ref={service3Ref} className={`border-l-4 border-[#a03223] pl-6 py-4 transition-all duration-700 delay-300 ${service3Visible ? "opacity-100 translate-x-0" : "opacity-0 -translate-x-8"}`}>
            <h3 className="text-2xl font-display font-semibold mb-3 text-foreground">
              Luxury Kitchens & Bathrooms
            </h3>
            <p className="text-muted-foreground font-sans leading-relaxed !text-base">Custom cabinetry, premium finishes, and seamless detailing designed for everyday comfort and timeless appeal.</p>
          </div>

          <div ref={service4Ref} className={`border-l-4 border-accent pl-6 py-4 transition-all duration-700 delay-500 ${service4Visible ? "opacity-100 translate-x-0" : "opacity-0 -translate-x-8"}`}>
            <h3 className="text-2xl font-display font-semibold mb-3 text-foreground">
              Smart Home Integration
            </h3>
            <p className="text-muted-foreground font-sans leading-relaxed !text-base">Discreet integration of automation, security, and intelligent systems — aligned with the aesthetic of your home.</p>
          </div>
        </div>
      </div>
    </section>;
}